package org.wordsapp

import kotlinx.browser.localStorage
import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlin.js.Promise

actual fun getBaseUrl(): String = ""

@Suppress("UNCHECKED_CAST")
actual suspend fun readClipboard(): String? {
    // Try the Clipboard API first (requires HTTPS)
    try {
        val clipboard = window.navigator.asDynamic().clipboard
        if (clipboard != null) {
            val promise = clipboard.readText() as Promise<String>
            val text = promise.await()
            if (!text.isNullOrBlank()) return text
        }
    } catch (_: Throwable) {
    }
    // Fallback: native browser prompt (works on HTTP and mobile)
    return window.prompt("Paste the spreadsheet URL:")
}

actual fun getPreference(key: String): String? = localStorage.getItem(key)

actual fun setPreference(key: String, value: String) {
    localStorage.setItem(key, value)
}

actual fun currentTimeMillis(): Long = kotlin.js.Date.now().toLong()
